export const RangeField = ({ field, register, watch }) => {
  const rangeValue = watch(field.id) || field.min || 0;
  
  return (
    <div>
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <span>{field.min || 0}</span>
        <span className="font-semibold">{rangeValue}</span>
        <span>{field.max || 100}</span>
      </div>
      <input
        id={field.id}
        type="range"
        {...register(field.id, field.validation)}
        min={field.min || 0}
        max={field.max || 100}
        step={field.step || 1}
        className="w-full"
        disabled={field.disabled}
      />
    </div>
  );
};